import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function WhoIsNotForSection() {
  const points = ['Buscas improvisar', 'Quieres saltarte el proceso', 'No quieres dar seguimiento', 'Prefieres depender de suerte, upline o motivación'];
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-dark relative border-t border-brand-gold/10" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-152">
          <h2 className="font-heading font-bold text-3xl md:text-4xl uppercase tracking-tight text-brand-text-muted mb-8 text-center" data-id="element-153">
            Esto no es para ti si…
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-154">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start bg-brand-white p-6 rounded-lg border border-red-200 shadow-sm" data-id="element-155">
                <XCircleIcon className="w-6 h-6 text-red-500/70 shrink-0 mr-4 mt-0.5" data-id="element-156" />
                <span className="text-brand-text-muted text-lg" data-id="element-157">{point}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}